import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { OrganizationLogoComponent } from './organization-logo';

@NgModule({
  declarations: [
    OrganizationLogoComponent
  ],
  imports: [
    IonicPageModule.forChild(OrganizationLogoComponent)
  ],
  exports: [
    OrganizationLogoComponent
  ]
})
export class OrganizationLogoModule {}



// WEBPACK FOOTER //
// ./src/components/organization-logo/organization-logo.module.ts